module.exports = __webpack_public_path__ + "static/media/subGoogle2.d2f45232.png";